/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Grid, Image, Modal, Row, Typography } from 'antd';
import viewExampleImage from '../../assets/illustrations/viewExampleImage.jpg';

const { useBreakpoint } = Grid;

const WebchatDeploymentExampleModal = ({
  isModalOpen=false,
  onModalClose=() => {},
  onModalConfirm=() => {},
  loader=false
}) => {
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const isMobileSize = (screens.xs || screens.sm) && !screens.lg && !screens.md;

  return (
    <Modal
      destroyOnClose
      title={
        <Fragment>
          <Typography.Title level={4} className="mb-0">
            {t('Chat Box Example')}
          </Typography.Title>
          <Typography.Text className="text-muted">
            {t('How settings apply')}
          </Typography.Text>
        </Fragment>
      }
      open={isModalOpen}
      onCancel={onModalClose}
      onOk={onModalClose}
      centered
      footer={[]}
    >
      <Row gutter={24}>
        <Col span={24}>
          <Image
            width={'100%'}
            height={'100%'}
            preview={!!isMobileSize}
            src={viewExampleImage}
          />
        </Col>
      </Row>
    </Modal>
  );
};

WebchatDeploymentExampleModal.propTypes = {
  isModalOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalConfirm: PropTypes.func,
  loader: PropTypes.bool,
  deploymentToCopySnippet: PropTypes.object
};

export default WebchatDeploymentExampleModal;
